<script setup>
import { onServerPrefetch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useGetData } from '../composable/useGetData.js'
import { useGlobalHeader } from '../composable/useGlobalHeader.js'
import { useStore } from '../store.js'
const { addParams } = useGlobalHeader()

const store = useStore()
const { sideMenuList } = storeToRefs(store)
const props = defineProps({
  devDomains: { type: Object, default: () => {} }
})
const { getSideMenuList } = useGetData(props.devDomains)

onServerPrefetch(async () => {
  sideMenuList.value = await getSideMenuList()
})

onMounted(async () => {
  if (!sideMenuList.value) sideMenuList.value = await getSideMenuList()
})

</script>

<template>
  <section class="headerOverlayMenu">
    <ul class="headerListMenu__group">
      <li
        v-for="menu in sideMenuList"
        :key="menu"
        class="headerListMenu__group"
      >
        <p class="headerListMenu__title">
          {{ menu.title }}
        </p>
        <ul class="headerListMenu even">
          <li
            v-for="content in menu.contents"
            :key="content"
            class="headerListMenu__item"
          >
            <a
              :href="addParams(content.link, 'header')"
              class="link"
            >
              <img
                :src="content.icon"
                width="20"
                height="20"
                loading="lazy"
                class="ico"
                alt=""
              >
              {{ content.text }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<style scoped>
.headerListMenu__group:not(:last-child) {
  margin-bottom: 10px;
}

.headerListMenu__title {
  font-weight: bold;
}

.headerListMenu {
  -ms-flex-wrap: wrap;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
}

.headerListMenu__item {
  width: 50%;
  border: 1px solid #ccc;
  border-bottom: none;
}

.headerListMenu__item:nth-child(odd) {
  border-left: none;
}

.headerListMenu__item:nth-child(even) {
  border-right: none;
  border-left: none;
}

.headerListMenu.odd li:nth-last-child(2) {
  border-bottom: 1px solid #ccc;
}

.headerListMenu.odd li:last-child {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.headerListMenu.even li:nth-last-child(2),
.headerListMenu.even li:last-child {
  border-bottom: 1px solid #ccc;
}

.headerListMenu a {
  display: block;
  position: relative;
  padding: 5px;
  padding-left: 26px;
  color: #3569c0;
  font-size: 14px;
}

.headerListMenu .ico {
  visibility: baseline;
  position: absolute;
  top: 5px;
  left: 5px;
  width: 16px;
  margin-right: 0.5em;
  float: left;
}

.headerListMenu .ico img {
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>
